import { Injectable } from "@angular/core";

// other services
import { HttpClient } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// models
import { Agenda } from "../models/agenda";
import { SpeakerQuestion } from "../models/speaker-question";

// configuration
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class AgendaService {
    /**
     * constructor
     *
     * @param jwtHttp
     */
    constructor(
        private http: HttpClient
    ) { }

    /**
     * get agendas by event
     *
     * @return {Observable<any>}
     */
    public getListByEvent(eventId: number): Observable<any> {
        return this.http.get(environment.api + '/event/' + eventId + '/agenda');
    }

    /**
     * get by id
     *
     * @return {Observable<any>}
     */
    public getById(id: number, eventId: number): Observable<any> {
        return this.http.get(environment.api + '/event/' + eventId + '/agenda/' + id);
    }

    /**
     * create
     *
     * @param group
     *
     * @return {Observable<any>}
     */
    public create(agenda: Agenda): Observable<any> {
        return this.http.post(environment.api + '/event/' + agenda.event_id + '/agenda', agenda);
    }

    /**
     * update
     *
     * @param agenda
     *
     * @return {Observable<any>}
     */
    public update(agenda: Agenda): Observable<any> {
        return this.http.put(environment.api + '/event/' + agenda.event_id + '/agenda/' + agenda.id, agenda);
    }

    /**
     * destroy by id
     *
     * @param id
     *
     * @return {Observable<any>}
     */
    public delete(id: number, eventId: number): Observable<any> {
        return this.http.delete(environment.api + '/event/' + eventId + '/agenda/' + id);
    }


    /**
     * get agendas by event
     *
     * @return {Observable<any>}
     */
    public getQuestionListByEvent(eventId: number): Observable<any> {
        return this.http.get(environment.api + '/event/' + eventId + '/question');
    }

    /**
     * get by id
     *
     * @return {Observable<any>}
     */
    public getQuestionById(id: number, eventId: number): Observable<any> {
        return this.http.get(environment.api + '/event/' + eventId + '/question/' + id);
    }

    /**
     * create
     *
     * @param group
     *
     * @return {Observable<any>}
     */
    public createQuestion(eventId: number, question: SpeakerQuestion): Observable<any> {
        return this.http.post(environment.api + '/event/' + eventId + '/question', question);
    }

    /**
     * update
     *
     * @param agenda
     *
     * @return {Observable<any>}
     */
    public updateQuestion(eventId: number, question: SpeakerQuestion): Observable<any> {
        return this.http.put(environment.api + '/event/' + eventId + '/question/' + question.id, question);
    }

    /**
     * destroy by id
     *
     * @param id
     *
     * @return {Observable<any>}
     */
    public deleteQuestion(id: number, eventId: number): Observable<any> {
        return this.http.delete(environment.api + '/event/' + eventId + '/question/' + id);
    }
}
